"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var util_1 = require("@antv/util");
var global_1 = require("../../base/global");
var layer_1 = tslib_1.__importDefault(require("../column/layer"));
var GroupColumnLayer = /** @class */ (function (_super) {
    tslib_1.__extends(GroupColumnLayer, _super);
    function GroupColumnLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'groupColumn';
        return _this;
    }
    GroupColumnLayer.getDefaultOptions = function () {
        return util_1.deepMix({}, _super.getDefaultOptions.call(this), {
            yAxis: {
                title: {
                    visible: true,
                },
            },
        });
    };
    GroupColumnLayer.prototype.getResponsiveTheme = function () {
        return this.themeController.getResponsiveTheme('column');
    };
    GroupColumnLayer.prototype.addGeometry = function () {
        _super.prototype.addGeometry.call(this);
    };
    GroupColumnLayer.prototype.adjustColumn = function (column) {
        column.adjust = [
            {
                type: 'dodge',
                marginRatio: 0.1,
            },
        ];
    };
    return GroupColumnLayer;
}(layer_1.default));
exports.default = GroupColumnLayer;
global_1.registerPlotType('groupColumn', GroupColumnLayer);
//# sourceMappingURL=layer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/group-column/layer.js
// module id = 911
// module chunks = 37